/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/reallocation_time': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 1a9 9 0 100 18 9 9 0 000-18zm0 2a7 7 0 110 14 7 7 0 010-14z"/><path pid="1" d="M9 5h2v4.600l3.200 1.900-1 1.700L9 10.700z"/>'
  }
})
